export const MODAL_THEMES = {
    LIGHT: "LIGHT",
    DARK: "DARK",
} as const

export type ModalTheme = keyof typeof MODAL_THEMES
